<template>
  <div>
    v1.8.6 (Commit 85bc6d9)
  </div>
</template>

<script>
export default {
  name: 'ShowVersion',
}
</script>

